import React from 'react';
import Ratings from 'react-ratings-declarative';

function RatingListItem(props) {

    const isValid = () => {
        let user = JSON.parse(localStorage.getItem('user'));
        console.log(user);
        return (user.role === "ROLE_ADMINISTRATOR");
    }
    return (
        <div className="col-lg-4 col-md-6 col-sm-12 d-flex">
            <div className='card card-spacer'>
                <div className="row">
                    <div className="card-body">
                        <h4 className="card-title">{props.userName}</h4>
                        <Ratings
                            rating={props.rating/2}
                            widgetDimensions="30px"
                            widgetSpacings="5px"
                        >
                            <Ratings.Widget widgetRatedColor="orange" />
                            <Ratings.Widget widgetRatedColor="orange" />
                            <Ratings.Widget widgetRatedColor="orange" />
                            <Ratings.Widget widgetRatedColor="orange" />
                            <Ratings.Widget widgetRatedColor="orange"/>
                        </Ratings>

                        <p className="card-text">{props.ratingText}</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default RatingListItem;


// WEBPACK FOOTER //
// ./src/components/RatingListItem/RatingListItem.jsx